import React from "react";
import Box from "@mui/material/Box";
import { LazyLoadImage } from "react-lazy-load-image-component";

import DefaultCover from "../../../assets/images/cover.jpg"


export default function () {
    return <Box className="ImageBox">
        <LazyLoadImage
            src={"https://cdn.tcfglobal.org/fundraiser-page-default-images/April2022/IQYJf9IHzpNmACLTi5Ik.jpg"} // use normal <img> attributes as props
            effect="blur"
            threshold='200'
            onError={(e) => {
                e.target.onerror = null;
                e.target.src = DefaultCover
            }}
        />
    </Box>
}